var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCemetery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u041A\\u043B\\u0430\\u0434\\u043E\\u0432\\u0438\\u0449\\u0435",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.847,
    height: 14.848,
    viewBox: "0 0 14.847 14.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1664",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1664",
    d: "M149.184,4.4h1.787V9.929c.175-.012.35-.024.53-.024a7.641,7.641,0,0,1,1.454.138V4.4h1.787a.4.4,0,0,0,.4-.4V2.822a.4.4,0,0,0-.4-.4h-1.787V.4a.4.4,0,0,0-.4-.4h-1.176a.4.4,0,0,0-.4.4V2.418h-1.787a.4.4,0,0,0-.4.4V4A.4.4,0,0,0,149.184,4.4Z",
    transform: "translate(-144.294)",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1665",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1665",
    d: "M.424,157.114a.3.3,0,0,0,.23.023l1.278-.383.994,3.314a4.689,4.689,0,0,1,1.283-.884l-.856-2.856,1.279-.384a.3.3,0,0,0,.2-.376l-.253-.842a.3.3,0,0,0-.376-.2l-1.28.384-.432-1.441a.3.3,0,0,0-.376-.2l-.842.253a.3.3,0,0,0-.2.376l.432,1.441-1.278.383a.3.3,0,0,0-.2.376l.253.842A.3.3,0,0,0,.424,157.114Z",
    transform: "translate(-0.012 -148.631)",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1666",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1666",
    d: "M324.959,159.294l-.119.871a.3.3,0,0,0,.258.34l1.322.181-.384,2.8a4.061,4.061,0,0,1,1.393-.248c.046,0,.091,0,.137.006l.323-2.357,1.323.181a.3.3,0,0,0,.34-.258l.119-.87a.3.3,0,0,0-.258-.34l-1.324-.181.2-1.49a.3.3,0,0,0-.258-.34l-.871-.119a.3.3,0,0,0-.34.258l-.2,1.49-1.322-.181A.3.3,0,0,0,324.959,159.294Z",
    transform: "translate(-315.042 -152.718)",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1667",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1667",
    d: "M14.906,361.938a2.9,2.9,0,0,0-1.7.521,5.333,5.333,0,0,0-3.485-1.136c-1.906,0-3.519.785-4.068,1.868a3.505,3.505,0,0,0-.4-.025,2.723,2.723,0,0,0-2.641,1.571.4.4,0,0,0,.381.539H16.045a1.145,1.145,0,0,0,.792-.318,1.59,1.59,0,0,0,.529-1.148A2.226,2.226,0,0,0,14.906,361.938Z",
    transform: "translate(-2.519 -350.428)",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCemetery);
export default __webpack_public_path__ + "static/media/Cemetery.c008a861b1bcb81c7abdd8bb3f9f9fdf.svg";
export { ForwardRef as ReactComponent };